import { format } from '@avensia/nitro5-scope';
export default function (property, args) {
    let value = property ? property.$c : null;
    if (typeof value === 'string' && args) {
        value = format(value, args);
    }
    return value;
}
